// © Microsoft Corporation. All rights reserved.

import { ConfigOrigins } from "@msnews/core-contracts";
import { memoize } from "lodash-es";
import { useLocalConfigs } from "../../utilities";

/**
 * BlobFetcher
 * This is for downloading the blob according to the url.
 */

// todo: use PCS headdata response here for the assets.msn.com hardcoded part?
const gitConfigBaseUrl = "https://assets.msn.com/periconfigs/";

// todo: Figure out how to not specify the port
const gitLocalConfigBaseUrl = "https://localhost.msn.com:9000/";

// Memoize the fetchAsyncNotMemoized function to return promises when it is continuing to fetch.
export const fetchAsync = memoize(fetchAsyncNotMemoized);

/**
 * This function fetches the file from a combination of provided relative url and the const GIT config base url.
 * @param relativeUrl to be used to fetch the blob
 * @param configType featureConfigs | featureManifests | localizationConfigs | localizationManifests configType
 * @param configOrigins Indicates if configs should be served from local repo
 */
export async function fetchAsyncNotMemoized(relativeUrl: string, configType?: string, configOrigins?: ConfigOrigins): Promise<any> {
    if (!relativeUrl) {
        // Logs error later in Resolver.ts
        throw new Error("BlobFetcher.ts: Fetch Error: Relative Url is null or undefined.");
    }
    const fetchUrl = useLocalConfigs(configType, configOrigins)
        ? gitLocalConfigBaseUrl + relativeUrl   // File names are case sensitive for local look up but not for Azure Blob Storage
        : gitConfigBaseUrl + relativeUrl.toLowerCase();
    const fetchPromise = fetch(fetchUrl).then(response => {
        if (response.ok) {
            return response.json();
        }

        // Logs error later in Resolver.ts
        throw new Error(`Non-200 response, Status: ${response.status}, StatusText: ${response.statusText}, fetch url: ${fetchUrl}`);
    }).catch(error => {
        // Catches json parsing and fetch errors.
        throw new Error(`BlobFetcher.ts: Fetch Error: fetch url: ${fetchUrl}, error: ${error}.`);
    });

    return fetchPromise;
}
